import { extend } from 'flarum/extend';
import HeaderSecondary from 'flarum/components/HeaderSecondary';
import LinkButton from 'flarum/components/LinkButton';
import ChatPage from './components/ChatPage';

export default function addChatPage() {
    app.routes.chat = { path: '/chat', component: ChatPage };

    extend(HeaderSecondary.prototype, 'items', function (items) {
        // Masquer le lien Chat pour les visiteurs non connectés
        if (!app.session.user) return;

        items.add('chat',
            <LinkButton icon="fas fa-comments" href={app.route('chat')} className="Button Button--link">
                {app.translator.trans('xelson-chat.forum.index.chat_link')}
            </LinkButton>,
            5
        );
        // Ludothèque / For the drama / Blog / Archives déplacés vers la sidebar
        // (IndexPage.navItems) par l'extension cestpasdujdr/flarum-ext-ludotheque.
        // Voir docs/plans/2026-06-05-header-declutter-nav-design.md
    });
}
